import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

export const GoogleAdsActionsPopoverContent = styled(PopoverContent)`
    box-sizing: border-box;
    width: 220px;
    padding: 8px;
`;

export const GoogleAdsActionsListItem = styled.button`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 10px 12px;
    border: none;
    border-radius: 3px;
    background: none;
    cursor: pointer;
    text-align: left;

    &:hover {
        background: ${colorsPalettes.carbon[25]};
    }
`;

export const GoogleAdsActionsMixedDescription = styled.div`
    padding: 6px 12px 8px;
    color: ${colorsPalettes.carbon[400]};
`;
